(function () {
  const initCollapsibleContent = (section) => {
    const items = section.querySelectorAll(".fap-content__item");

    if (!items.length) return;

    function setInitialState(item) {
      const answer = item.querySelector(".fap-content__answer");
      const toggle = item.querySelector(".fap-content__toggle");

      if (!answer || !toggle) return;
      answer.style.transition = "none";

      if (item.classList.contains("active")) {
        answer.style.display = "block";
        answer.style.height = "auto";
      } else {
        answer.style.display = "block";
        answer.style.height = "0px";
      }

      setTimeout(() => {
        answer.style.removeProperty("transition");
      }, 600);
    }

    function openItem(item) {
      const answer = item.querySelector(".fap-content__answer");
      const toggle = item.querySelector(".fap-content__toggle");

      if (!answer || !toggle) return;

      item.classList.add("active");

      answer.style.display = "block";
      answer.style.height = answer.scrollHeight + "px";

      const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        if (item.classList.contains("active")) {
          answer.style.height = "auto";
        }
        answer.removeEventListener("transitionend", onEnd);
      };

      answer.addEventListener("transitionend", onEnd);
    }

    function closeItem(item) {
      const answer = item.querySelector(".fap-content__answer");
      const toggle = item.querySelector(".fap-content__toggle");

      if (!answer || !toggle) return;

      answer.style.height = answer.scrollHeight + "px";
      answer.offsetHeight;

      item.classList.remove("active");
      answer.style.height = "0px";
    }

    function toggleItem(item) {
      const isOpen = item.classList.contains("active");

      items.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains("active")) {
          closeItem(otherItem);
        }
      });

      if (isOpen) {
        closeItem(item);
      } else {
        openItem(item);
      }
    }

    items.forEach((item) => {
      const toggle = item.querySelector(".fap-content__toggle");

      setInitialState(item);

      if (!toggle) return;

      toggle.addEventListener("click", () => {
        toggleItem(item);
      });

      toggle.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          toggleItem(item);
        }
      });
    });

    // spacer helper: set --spacer on info containers to match second child's height

    function updateInfoSpacers() {
      const infos = section.querySelectorAll(".fap-content__info");
      infos.forEach((info) => {
        const children = Array.from(info.children).filter(
          (n) => n.nodeType === 1
        );
        if (children.length >= 2) {
          const bottom = children[1];
          const height = bottom.offsetHeight;
          info.style.setProperty("--spacer", height + "px");
        } else {
          info.style.removeProperty("--spacer");
        }
      });
    }

    // run on init and resize (debounced)
    updateInfoSpacers();

    let resizeTimer = null;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateInfoSpacers, 120);
    });

    window.addEventListener("resize", () => {
      section
        .querySelectorAll(
          ".fap-content__item.active .fap-content__answer"
        )
        .forEach((answer) => {
          answer.style.height = "auto";
        });
    });
  };

  const startCollapsibleSlideshow = (images) => {
    if (images.length > 1) {
      let speed =
        Number(images.closest(".fap-content__gallery").data("speed")) *
        1000;
      var currentImageIndex = 0;
      let fadeSpeed = 1000;

      images.eq(currentImageIndex).fadeIn(fadeSpeed);

      // Start the slideshow
      var interval = setInterval(function () {
        let nextImageIndex = (currentImageIndex + 1) % images.length;

        // Crossfade: one fades in while the other fades out
        images.eq(currentImageIndex).fadeOut(fadeSpeed);
        images.eq(nextImageIndex).fadeIn(fadeSpeed);

        currentImageIndex = nextImageIndex;
      }, speed);
    }
  };

  const initGallery = () => {
    if ($(".fap-content").length > 0) {
      $(".fap-content").each(function (index, item) {
        var images = $(this).find(
          ".fap-content__gallery--image-wrapper"
        );

        startCollapsibleSlideshow(images);
      });
    }
  };

  initCollapsibleContent(document.currentScript.parentElement);
  initGallery();

  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("shopify:section:load", function (event) {
      initCollapsibleContent(event.target);
      initGallery();
    });
  });
})();
